import React from 'react';
import { Link } from 'react-router-dom';
import './Reports.css';

const Reports = () => {
  const reportCategories = [
    {
      title: 'Relatórios por Categoria',
      description: 'Análises detalhadas do comportamento financeiro por categoria',
      reports: [
        {
          path: '/reports/category',
          title: 'Relatório de Categorias',
          description: 'Visão detalhada das transações por categoria e período'
        },
        {
          path: '/reports/category-analysis',
          title: 'Análise por Categoria',
          description: 'Comparativos e tendências por categoria'
        }
      ]
    },
    {
      title: 'Análises Temporais',
      description: 'Evolução dos dados financeiros ao longo do tempo',
      reports: [
        {
          path: '/reports/temporal-analysis',
          title: 'Análise Temporal',
          description: 'Evolução das receitas e despesas ao longo dos meses'
        },
        {
          path: '/reports/monthly-comparison',
          title: 'Comparativo Mensal',
          description: 'Comparação detalhada entre diferentes meses'
        },
        {
          path: '/reports/yearly-summary',
          title: 'Resumo Anual',
          description: 'Visão consolidada dos resultados anuais'
        }
      ]
    },
    {
      title: 'Insights e Tendências',
      description: 'Análises inteligentes e descoberta de padrões',
      reports: [
        {
          path: '/reports/financial-insights',
          title: 'Insights Financeiros',
          description: 'Descoberta automática de padrões e oportunidades'
        },
        {
          path: '/reports/budget-analysis',
          title: 'Análise Orçamentária',
          description: 'Comparação entre orçado e realizado'
        },
        {
          path: '/reports/cashflow-projection',
          title: 'Projeção de Fluxo de Caixa',
          description: 'Previsões baseadas em histórico e tendências'
        }
      ]
    },
    {
      title: 'Relatórios Executivos',
      description: 'Visões consolidadas para tomada de decisão',
      reports: [
        {
          path: '/reports/executive-summary',
          title: 'Resumo Executivo',
          description: 'Dashboard executivo com KPIs principais'
        },
        {
          path: '/reports/performance-metrics',
          title: 'Métricas de Performance',
          description: 'Indicadores de desempenho financeiro'
        }
      ]
    }
  ];

  return (
    <div className="reports-container">
      <div className="reports-header">
        <h1>Relatórios Financeiros</h1>
        <p>Central de análises e insights para o 2centavos</p>
      </div>

      <div className="reports-grid">
        {reportCategories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="report-category">
            <div className="category-header">
              <h2>{category.title}</h2>
              <p>{category.description}</p>
            </div>
            
            <div className="reports-list">
              {category.reports.map((report, reportIndex) => (
                <Link 
                  key={reportIndex}
                  to={report.path} 
                  className="report-card"
                >
                  <h3>{report.title}</h3>
                  <p>{report.description}</p>
                  <div className="report-arrow">→</div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports; 